export default __webpack_public_path__ + "static/img/vogue_scene_animated_0167.b934433.webp";